import { gql } from '@/core/shared/api';
import EventBus from '@/core/shared/services/EventBus';
import { initEcho, checkEchoService } from '@/core/echo';
import { initLaunchDarkly } from '@/core/shared/setup/launchDarkly';
import { initSBVRPermissions } from '@/core/shared/setup/permissions';
import useTaxForm from '@/core/compositions/useTaxForm';

export function goToTaxForm () {
  EventBus.$emit('router:push', { name: 'tax-details' });
}

export function goToOrganizationDetails () {
  EventBus.$emit('router:push', { name: 'organization-details' });
}

export const initUser = async ({
  state,
  dispatch,
  rootState,
  rootGetters,
  commit,
}) => {
  await dispatch(
    'getOrganizationBasics',
    `
    type
    businessType
    address
    country
    city
    postalCode
    taxForm {
      id
      status
      url
    }
    financeEmail
    tenant {
      enterpriseContentOwnerships
    }
  `,
  );

  const organization = rootGetters.currentOrganization;
  const user = rootGetters.currentUser;

  initLaunchDarkly(user, organization);
  initSBVRPermissions(user, organization);

  if (organization && organization.type === 'developer') {
    const taxFormComplete = !!organization.taxForm;
    const { hasSkippedTaxForm } = useTaxForm();
    if (!taxFormComplete && !hasSkippedTaxForm.value) {
      EventBus.$emit('router:push', { name: 'sign-up-welcome' });
    }

    dispatch('getContentOwnerships');
    dispatch('getCountries', 'countryCode effectiveParityRate');
    dispatch('getRegions');

    initEcho(user.pusherConfiguration, state.auth.token);

    await checkEchoService();
    window.echo
      .private('App.Organization.' + organization.id)
      .listen('.ContentOwnership', data => {
        if (rootState.contentOwnerships.allowWebsocketUpdates) {
          dispatch('getContentOwnership', data.contentOwnership.id);
        }
      });
  } else {
    commit('setFlash', {
      type: 'error',
      message: 'You are not a Content Creator',
    });
    dispatch('logout');
  }
};

export const cleanUpUser = ({ commit }) => {
  // commit('setContentOwnership', [])
  // window.echo = null
};

export const uploadTaxForm = async (
  { commit, dispatch, rootGetters },
  taxForm,
) => {
  commit('setLoading', true);
  try {
    const mutation = `
    mutation uploadTaxForm ($blob: Upload) {
      uploadTaxForm (blob: $blob) {
        id
        status
        url
      }
    }`;
    const { uploadTaxForm } = await gql.requestWithBlobs(
      mutation,
      { blob: null },
      {
        name: 'blob',
        file: taxForm,
      },
    );
    dispatch('insertEntities', {
      name: 'Organization',
      payload: {
        id: rootGetters.currentOrganization.id,
        taxForm: uploadTaxForm,
      },
    });
    commit('organization/set', { path: 'taxForm', value: uploadTaxForm });
  } finally {
    commit('setLoading', false);
  }
};
